import { render } from "./LifecycleStageSelector.vue?vue&type=template&id=a639c802&scoped=true"
import script from "./LifecycleStageSelector.vue?vue&type=script&lang=js"
export * from "./LifecycleStageSelector.vue?vue&type=script&lang=js"

import "./LifecycleStageSelector.vue?vue&type=style&index=0&id=a639c802&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a639c802"]])

export default __exports__